<div class="container-fluid">
  <div class="mega_body-content">
    <div class="col-12- col-sm-12 col-md-12 col-lg-12">
      <ng-container *ngIf="isAllMegasHaveErrors">
        <div class="row error-banner-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon float-end">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-8 col-sm-8 col-md-8 col-lg-9">
            <p class="file-format-text">
              All of the pools in your file contained errors and cannot be allocated.<span
                class="download-report-try-again"
                (click)="downloadErrorReport()"
              >
                Download the Error Report and try again.</span
              >
              A copy of the Error Report has been sent to your email address.
            </p>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Validate Pools</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="line-break"></div>
    </div>
    <div
      class="col-12 col-sm-12 col-md-12 col-lg-12 detected-megas-row d-flex flex-wrap align-items-center"
    >
      <span class="detected-megas-count">Detected Pools: {{ detectedMegasFromPool }} Total</span>
      <span class="cancel-upload-circle-icon-and-link">
        <i class="fa fa-times-circle cancel-upload-link-icon" (click)="handleCancelUpload()"></i>
        <a class="cancel-upload-link" (click)="handleCancelUpload()">Cancel Upload</a>
      </span>
      <span class="ms-auto">
        <ul class="list-inline upload-process-statuses-list">
          <li class="validated-text">
            Validated: {{ countForValidatedMegas }} <span class="show-pipe-symbol">|</span>
          </li>
          <li class="success-text">
            Success: {{ countForSuccessMegas }} <span class="show-pipe-symbol">|</span>
          </li>
          <li class="errors-text">Errors: {{ countForErrorsMegas }}</li>
          <span class="continue-button">
            <button
              class="button fm-primary-button"
              id="continue-button"
              type="button"
              [disabled]="isContinueButtonDisabled"
              (click)="navigateToAllocatePoolsPage()"
            >
              Continue
            </button>
          </span>
        </ul>
      </span>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="validatedMegaList !== null">
      <div class="fm-cdx-table">
        <table class="fm-cdx-table__static">
          <thead>
            <tr class="th_row">
              <th class="th_column validate-pool-mega-number-col wd-15">POOL #</th>
              <th class="th_column validate-pool-tool-pools-col pool-count">Collateral Pools</th>
              <th class="th_column validate-pool-tool-pools-col wd-40"></th>
              <th class="th_column validate-pool-tool-pools-col"></th>
              <th class="th_column validate-pool-tool-pools-col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="td_row commit-mega-table-header"
              *ngFor="
                let validatedPoolItem of validatedMegaList;
                let j = index;
                trackBy: trackByIdentity
              "
            >
              <td class="td_cell wd-15">
                <span class="validate-pool-mega-number">{{ validatedPoolItem?.megaNumber }}</span>
              </td>
              <td class="td_cell pool-count">
                <span class="validate-pool-total-pools-count">{{
                  validatedPoolItem?.poolCount
                }}</span>
              </td>
              <td class="td_cell wd-50">
                <span class="status-align">
                  <ng-container
                    *ngIf="countForValidatedMegas === 0 && megaValidationStatus[j] == null"
                  >
                    <span class="pr-20"
                      ><i
                        class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                      ></i
                    ></span>
                    <span class="validate-pool-status">{{ 'Queued' }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="megaValidationStatus[j] !== null && megaValidationStatus[j] === 'Queued'"
                  >
                    <span class="pr-20"
                      ><i
                        class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                      ></i
                    ></span>
                    <span class="validate-pool-status">{{ 'Queued' }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      megaValidationStatus[j] !== null && megaValidationStatus[j] === 'Validating'
                    "
                  >
                    <span class="pr-20"
                      ><i
                        class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                      ></i
                    ></span>
                    <span class="validate-pool-status"
                      >{{ 'Validating' }} - {{ poolProgressCount[j] ? poolProgressCount[j] : 0 }} of
                      {{ validatedPoolItem?.poolCount }} completed</span
                    >
                  </ng-container>
                  <ng-container
                    *ngIf="
                      megaValidationStatus[j] !== null &&
                      megaValidationStatus[j] === 'Complete' &&
                      countForValidatedMegas !== 0
                    "
                  >
                    <span class="pr-mega-error"
                      ><i
                        class="fa fa-check-circle icon-disable completed-green icons-for-validating-status"
                      ></i
                    ></span>
                    <span class="validate-pool-status">{{ 'Complete' }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      megaValidationStatus[j] !== null &&
                      megaValidationStatus[j] === 'Pool Error' &&
                      countForValidatedMegas !== 0
                    "
                  >
                    <span class="pr-mega-error">
                      <i
                        class="fa fa-exclamation-circle tooltip-error icon-disable error-red icons-for-validating-status"
                        data-bs-toggle="tooltip"
                        data-bs-html="true"
                        title="This is a not a valid pool. For more details, a full error report will be available at the end of the upload process."
                      >
                      </i
                    ></span>
                    <span class="validate-pool-status error-red">{{ 'Pool Error' }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      megaValidationStatus[j] !== null &&
                      megaValidationStatus[j] === 'Collateral Pool Error' &&
                      countForValidatedMegas !== 0 &&
                      poolFailureCount[j] === 1
                    "
                  >
                    <span class="pr-mega-error">
                      <i
                        class="fa fa-exclamation-circle tooltip-error icon-disable error-red icons-for-validating-status"
                        data-bs-toggle="tooltip"
                        data-bs-html="true"
                        title=" There are {{
                          poolFailureCount[j]
                        }} collateral pool(s) with errors. A full error report will be available at the end of the upload process."
                      >
                      </i
                    ></span>
                    <span class="validate-pool-status error-red">{{
                      'Collateral Pool Error'
                    }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      megaValidationStatus[j] !== null &&
                      megaValidationStatus[j] === 'Collateral Pool Error' &&
                      countForValidatedMegas !== 0 &&
                      poolFailureCount[j] > 1
                    "
                  >
                    <span class="pr-mega-error">
                      <i
                        class="fa fa-exclamation-circle tooltip-error icon-disable error-red icons-for-validating-status"
                        data-bs-toggle="tooltip"
                        data-bs-html="true"
                        title="There are {{
                          poolFailureCount[j]
                        }} collateral pool(s) with errors. A full error report will be available at the end of the upload process."
                        [ngClass]="{
                          'pool-count-one-digit': poolProgressCountLength[j] === 1,
                          'pool-count-two-digit': poolProgressCountLength[j] === 2,
                        }"
                      >
                      </i
                    ></span>
                    <span class="validate-pool-status error-red">{{
                      'Collateral Pool Error'
                    }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      megaValidationStatus[j] !== null &&
                      megaValidationStatus[j] === 'File Error' &&
                      countForValidatedMegas !== 0
                    "
                  >
                    <span class="pr-mega-error">
                      <i
                        class="fa fa-exclamation-circle tooltip-error icon-disable error-red icons-for-validating-status"
                        data-bs-toggle="tooltip"
                        data-bs-html="true"
                        title="The information for this pool in your file was not formatted correctly and cannot be allocated. Details will be included in the error report included at the end of the upload process."
                      >
                      </i
                    ></span>
                    <span class="validate-pool-status error-red">{{ 'File Error' }}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      megaValidationStatus[j] !== null &&
                      megaValidationStatus[j] === 'System Error' &&
                      countForValidatedMegas !== 0 &&
                      poolFailureCount[j] > 1
                    "
                  >
                    <span class="pr-mega-error">
                      <i
                        class="fa fa-exclamation-circle tooltip-error icon-disable error-red icons-for-validating-status"
                        data-bs-toggle="tooltip"
                        data-bs-html="true"
                        title=" There are {{
                          poolFailureCount[j]
                        }} collateral pool(s) with errors. A full error report will be available at the end of the upload process."
                      >
                      </i
                    ></span>
                    <span class="validate-pool-status error-red">{{ 'System Error' }}</span>
                  </ng-container>
                </span>
              </td>
              <td class="td_cell"></td>
              <td class="td_cell"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="validation-pool-model-window" *ngIf="displayNavigateAwayPopup">
      <div class="panel panel-default fadeInUpBig">
        <div class="panel-body pool-info-cancel-confirmation-model">
          <h4>You are attempting to leave this page.</h4>
          <br />
          <p>
            By doing so, none of your pool information will be allocated and all of your work to
            this point will be lost.
          </p>
          <br />
          <h4>Do you wish to proceed?</h4>
          <br />
          <button class="button fm-tertiary-button" (click)="displayNavigateAwayPopup = false">
            NO
          </button>
          <button class="button fm-primary-button" (click)="navigatePageTo(destinationUrl)">
            YES
          </button>
        </div>
      </div>
    </div>

    <div class="validation-pool-model-window" *ngIf="dispalyCancelPopupWindow">
      <div class="panel panel-default fadeInUpBig">
        <div class="panel-body pool-info-cancel-confirmation-model">
          <ng-container>
            <h4 class="fw-bold">Cancel Upload?</h4>
            <p>
              By cancelling this upload, none of your pool information will be allocated and all of
              your work to this point will be lost.
            </p>
            <br />
            <h4 class="fw-bold">Do you wish to proceed?</h4>
            <br />
          </ng-container>
          <button
            class="button fm-tertiary-button cancel-popup-no-button"
            (click)="dispalyCancelPopupWindow = false"
          >
            NO
          </button>
          <button
            class="button fm-primary-button cancel-popup-yes-button"
            (click)="cancelUpload()"
            [disabled]="isYesButtonClickedToCancelUpload"
          >
            YES
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
